import { ContactNote } from "../model/ContactNote";
import axios from "axios";

export const fetchContactNotes = async (contactId: string): Promise<ContactNote[]> => {
    const url = window && "https://" +  window.location.host + "/ui/Commerce/";
    const res = await axios.get<ContactNote[]>(url + "ContactNotes/List?contactId=" + contactId);
    return res.data;
};

export const fetchContactNoteById = async (contactNoteId: string): Promise<ContactNote> => {
    const url = window && "https://" +  window.location.host + "/ui/Commerce/";
    const res = await axios.get<ContactNote>(url + "ContactNotes/Get?contactNoteId=" + contactNoteId);
    return res.data;
};

export const addOrUpdateContactNotes = async (contactNote: ContactNote): Promise<any> => {
    const url = window && "https://" +  window.location.host + "/ui/Commerce/";
    await axios.post<any>(url + "ContactNotes/AddOrUpdate", contactNote);
};

export const deleteContactNotes = async (contactNoteIds: string[]): Promise<any> => {
    const url = window && "https://" +  window.location.host + "/ui/Commerce/";
    await axios.delete<any>(url + "ContactNotes/Delete", { data: contactNoteIds });
};
